export const closeBrandPickerDialog = (modalId: string) => {
    const checkbox = document.getElementById(modalId) as HTMLInputElement | null
    if (checkbox) {
        checkbox.checked = false
    }
}
